// extracted by mini-css-extract-plugin
module.exports = {"InputBlock":"styles_InputBlock__2z08x"};